$(window).on('load resize', function(){
	let _object = $('[data-height]');
	_object.each(function(){
		let _objectPosition = $(this).offset();
		let _objectChildPosition = $(this).children().last().offset();
		let _objectHeight = $(this).children().last().outerHeight(true);
		$(this).height(_objectChildPosition.top - _objectPosition.top + _objectHeight);
	})
});
